import { useMemo } from "react";
import { cssColor } from "shared/src/utils/cssUtils";
import { useIdRef } from "shared/src/hooks/useIdRef";
import { type BackgroundFadeType } from "../types";

const fadeAlignmentMap = {
  center: "cui-top-0 cui-left-1/2 -cui-translate-x-1/2",
  top: "cui-top-0 cui-left-0", 
  bottom: "cui-bottom-0 cui-left-0",
  left: "cui-left-0",
  right: "cui-right-0"
}

export const BackgroundFade = ({ id, alignment = "center", size, gradientStops, opacity = 1}: BackgroundFadeType) => {
  const _id = typeof id === "string" && !id ? id : useIdRef({ str: "cui_bg-fade_" }).current;
  const _alignment = alignment in fadeAlignmentMap ? fadeAlignmentMap[alignment] : fadeAlignmentMap["center"];
  const _gradientDirection = alignment === "top" || alignment === "bottom" ? "to bottom" : "to right";
  const _style = useMemo(()=>{
    return {
      width: size?.width ?? 50,
      height: size?.height ?? "100%",
      opacity,
      backgroundImage: `linear-gradient(${_gradientDirection}, ${gradientStops?.map((stop) => {
        return `${cssColor(stop?.color)} ${stop?.location * 100}%`
      }).join(", ")})`
    }
  },[]);
  
  return <div id={_id} className={`cui-absolute ${_alignment}`} style={_style} />
}